<template>
  <!-- page-delete-diary -->
  <div class="page-delete-diary white--body" v-if="page_loaded">
    <section
      class="add_new_head add_new_head-h white--body tx--bege relative cover m_bg_blue-doc"
    >
      <div class="popup_close close-animate">
        <a @click="onClose"><CloseSvg /></a>
      </div>
      <div class="inner_width flex flex--column center">
        <h1 class="title">
          <span class="bold block desk-block">מחיקת בלוק מרפאה</span>
          {{ editBlock.block_type_name }}
        </h1>
        <div class="text">
          {{ editBlock.start_date }}
          {{ editBlock.dup_blocks.length > 0 ? "" : "(ללא חזרה)" }}
          <br />
          {{ insurance }}
        </div>
      </div>
    </section>
    <section class="page-edit-padd bg--white">
      <validation-observer ref="editBlockForm" class="block max--680">
        <form
          @submit.prevent="submitDeleteBlock"
          v-promise-btn="{ action: 'submit' }"
          autocomplete="off"
        >
          <div class="text desk-tx--28 mb-15 center let-1">
            האם ברצונך למחוק את כל הבלוקים הבאים או לתאריך הנבחר בלבד?
          </div>
          <div class="step-4-docs-group">
            <div class="form_check form_radio desk-no-marge">
              <label class="form_check_tx"
                >מחיקת בלוק ב - {{ editBlock.start_date }}
                {{ editBlock.dup_blocks.length > 1 ? "בלבד" : "" }}
                <input
                  type="radio"
                  name="edit_all_blocks"
                  v-model="update_all"
                  value="no"
                /><span class="checkmark"></span>
              </label>
            </div>
            <div
              class="form_check form_radio"
              v-if="editBlock.dup_blocks.length > 1"
            >
              <label class="form_check_tx"
                >מחיקת כל הבלוקים החוזרים הבאים
                <input
                  type="radio"
                  name="edit_all_blocks"
                  v-model="update_all"
                  value="yes"
                /><span class="checkmark"></span>
              </label>
            </div>
          </div>
          <div
            class="notif-box bg--error tx--red desk-flex desk-flex--content--center"
          >
            <Alert />
            לתשומת ליבך, לא ניתן לשחזר נתונים לאחר מחיקת בלוק המרפאה
          </div>
          <div class="flex flex--content--center">
            <div class="error-message center" v-if="serverMessage">
              {{ serverMessage }}
            </div>
            <button
              type="submit"
              class="bt_blue w-100 "
              :class="{ bt_disable: notValid }"
            >
              מחיקה
            </button>
          </div>
        </form>
      </validation-observer>
    </section>
  </div>
  <!-- end page-delete-diary -->
</template>

<script>
import { mapGetters } from "vuex";
import CloseSvg from "@/assets/img/svg/close.svg";
import Alert from "@/assets/img/svg/alert.svg";
import ConfirmDeleteBlock from "@/components/Popups/ConfirmDeleteBlock";
import Error from "@/components/Popups/Error";
import { getHash } from "../../../utilities/hash.js";

export default {
  name: "DeleteBlock",

  components: {
    CloseSvg,
    Alert
  },
  data: function() {
    return {
      page_loaded: false,
      serverMessage: "",
      block_repeat: "",
      editBlock: null,
      editAllBlock: false,
      start_time: "",
      end_time: "",
      update_all: ""
    };
  },
  mounted() {
    this.$API
      .getBlockInfo(this.$route.params.id)
      .then(res => {
        this.editBlock = res;
        this.start_time = res.start_time;
        this.end_time = res.end_time;
        this.page_loaded = true;
      })
      .catch(e => {
        this.$modal.show(Error);
      });
  },
  computed: {
    ...mapGetters(["activeDoctor", "activeUser"]),
    notValid() {
      if (!this.update_all) {
        return true;
      }
      return false;
    },
    insurance() {
      let ins = [];
      let all_ob = this.editBlock.appointments_ob;
      for (const key in all_ob) {
        if (ins.indexOf(all_ob[key].insurance) < 0) {
          ins.push(all_ob[key].insurance);
        }
      }
      return ins.join(",");
    }
  },
  methods: {
    submitDeleteBlock(value) {
      return new Promise((resolve, reject) => {
        this.serverMessage = "";

        this.$modal.show(ConfirmDeleteBlock, {
          block: this.editBlock,
          deleteAll: this.update_all
        });

        resolve(true);
      });
    },
    onClose() {
      const date = this.$moment(this.editBlock.start_date, "DD/MM/YYYY").format(
        "YYYY-MM-DD"
      );
      const hash = getHash({ blockId: "", date, view: "day" });
      this.$router.push(`/dashboard#${hash}`);
    }
  }
};
</script>
